import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
  createQuestionSet,
  createQuestion,
  fetchQuestionSet,
  deleteQuestion,
  addRewards,
  updateQuestion,
  employeeFeedbackList,
  employeeFeedbackDetails,
  getQuestions
} from "../../services/survey.js";

@Module({
  namespaced: true,
})
export default class survey extends VuexModule {
  //state
  questionList = [];
  employeeList = [];

  //Actions
  @Action
  public async createQuestionSet(payload) {
    try {
      const data = await createQuestionSet(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async createQuestion(payload) {
    try {
      const data = await createQuestion(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchQuestionSet() {
    try {
      const data = await fetchQuestionSet();
      this.context.commit("setQuestionSet", data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async deleteQuestion(payload) {
    try {
      const data = await deleteQuestion(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async addRewards(payload) {
    try {
      const data = await addRewards(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateQuestion(payload) {
    try {
      const data = await updateQuestion(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async employeeFeedbackList(id) {
    try {
      const data = await employeeFeedbackList(id);
      this.context.commit("setEmployeeFeedbackList", data);
      return data;
    } catch (error) {
      throw error;
    }
   }
  @Action
  public async employeeFeedbackDetails(payload) {
    try {
      const data = await employeeFeedbackDetails(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async getQuestions(id) {
    try {
      const data = await getQuestions(id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Mutation
  private setEmployeeFeedbackList(data) {
    this.employeeList = data;
  }
  @Mutation
  private setQuestionSet(data) {
    this.questionList = data;
  }
}
